import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Gift, Infinity as InfinityIcon, CircleSlash, ShoppingBag } from "lucide-react";
import { api } from "@/lib/api";

export const quotaText = (n) => (n === 1 ? "Hai 1 analisi disponibile" : `Hai ${n} analisi disponibili`);

export default function QuotaBanner({ hideBuy = false }) {
  const [q, setQ] = useState(null);
  useEffect(() => { api.get("/me/quota").then(({ data }) => setQ(data)).catch(() => {}); }, []);
  if (!q) return null;
  const [Icon, text] = q.unlimited
    ? [InfinityIcon, "Account Illimitato: puoi effettuare analisi senza limiti"]
    : q.remaining > 0 ? [Gift, quotaText(q.remaining)] : [CircleSlash, "Le tue analisi disponibili sono terminate"];
  return (
    <div className="rounded-xl border border-[#c9a96e] bg-[#ffffff] p-3" data-testid="quota-banner">
      <div className="flex items-center gap-3">
        <Icon size={18} className="shrink-0 text-[#b8975a]" />
        <p className="text-sm font-semibold text-[#0d2517]" data-testid="quota-banner-text">{text}</p>
      </div>
      {!q.unlimited && !hideBuy && (
        <Link to="/acquista" className="mt-2 flex items-center gap-1.5 pl-[30px] text-xs font-semibold text-[#0d2517] underline underline-offset-4" data-testid="quota-buy-link">
          <ShoppingBag size={13} /> {q.remaining > 0 ? "Acquista altre analisi" : "Acquista nuove analisi"}
        </Link>
      )}
    </div>
  );
}
